import { useEffect, useRef, useState } from 'react'
import {
    BooleanParam,
    NumberParam,
    StringParam,
    useQueryParams,
} from 'use-query-params'

import { getMessagesFilters } from '../../../../api/messages'
import useApiCall from '../../../../api/useApiCall'
import { ReactComponent as Settings } from '../../../../assets/icons/settings.svg'
import useOnClickOutside from '../../../../hooks/useOnClickOutside'
import { countFilters, DashArrayParam } from '../../../../utils/useQueryParams'

import MessagesFiltersMenu from './MessagesFiltersMenu/MessagesFiltersMenu'
import MessagesFiltersOptions from './MessagesFiltersOptions/MessagesFiltersOptions'

import { joinClassNames } from '../../../../utils/styles'
import styles from './messages-filters.module.scss'

export enum MessagesFiltersCategoriesEnum {
    'ENTITIES' = 'entities',
    'INTENTS' = 'intents',
    'CHANNELS' = 'channels',
    'OTHER' = 'other',
}

export enum MessagesFiltersEnum {
    'ENTITIES' = 'entities',
    'INTENTS' = 'intents',
    'CHANNELS' = 'channels',
    'DATE_FROM' = 'date_from',
    'DATE_TO' = 'date_to',
    'INTENT_CONFIDENCE_FROM' = 'intent_confidence_from',
    'INTENT_CONFIDENCE_TO' = 'intent_confidence_to',
    'ENTITY_CONFIDENCE_FROM' = 'entity_confidence_from',
    'ENTITY_CONFIDENCE_TO' = 'entity_confidence_to',
    'MESSAGE_VALIDATED' = 'message_validated',
}

function MessagesFilters() {
    const [query] = useQueryParams({
        [MessagesFiltersEnum.ENTITIES]: DashArrayParam,
        [MessagesFiltersEnum.INTENTS]: DashArrayParam,
        [MessagesFiltersEnum.CHANNELS]: DashArrayParam,
        [MessagesFiltersEnum.DATE_FROM]: StringParam,
        [MessagesFiltersEnum.DATE_TO]: StringParam,
        [MessagesFiltersEnum.INTENT_CONFIDENCE_FROM]: NumberParam,
        [MessagesFiltersEnum.INTENT_CONFIDENCE_TO]: NumberParam,
        [MessagesFiltersEnum.ENTITY_CONFIDENCE_FROM]: NumberParam,
        [MessagesFiltersEnum.ENTITY_CONFIDENCE_TO]: NumberParam,
        [MessagesFiltersEnum.MESSAGE_VALIDATED]: BooleanParam,
    })

    const [{ data: filtersOptions, loading }] = useApiCall(getMessagesFilters)

    const filtersRef = useRef<HTMLDivElement>(null)
    const [areFiltersOpen, setAreFiltersOpen] = useState(false)
    const [category, setCategory] = useState(
        MessagesFiltersCategoriesEnum.ENTITIES
    )
    const [filtersCount, setFiltersCount] = useState<number>()

    useOnClickOutside(filtersRef, () => setAreFiltersOpen(false))

    useEffect(() => {
        setFiltersCount(countFilters(query))
    }, [query])

    if (loading || !filtersOptions) {
        return null
    }

    const {
        intent_names: intents,
        entity_labels: entities,
        channel_names: channels,
    } = filtersOptions

    return (
        <div className={styles.messagesFilters__wrapper}>
            <button
                className={joinClassNames(
                    styles.messagesFilters__btn,
                    areFiltersOpen && styles.messagesFilters__btnActive
                )}
                onClick={() =>
                    setAreFiltersOpen((areFiltersOpen) => !areFiltersOpen)
                }
            >
                {filtersCount ? (
                    <div className={styles.messagesFilters__counter}>
                        {String(filtersCount)}
                    </div>
                ) : null}
                <Settings className={styles.messagesFilters__btnIcon} />
            </button>
            {areFiltersOpen && (
                <div className={styles.messagesFilters} ref={filtersRef}>
                    <MessagesFiltersMenu
                        category={category}
                        setCategory={setCategory}
                    />
                    <MessagesFiltersOptions
                        category={category}
                        filtersOptions={{ entities, intents, channels }}
                    />
                </div>
            )}
        </div>
    )
}

export default MessagesFilters
